import { createSlice } from "@reduxjs/toolkit";
import { ActionStatus } from "../../common/constants/action-status";
import { defaultApiState } from "../../common/constants/api-constants";
import { AddressBookState } from "./interfaces/address-book.interface";
import { fetchAddressBook } from "./store/address-book.thunks";

/*----- CREATE INITIAL STATE ------*/

export const addressBookStateInitialState: AddressBookState = defaultApiState;

/*----- CREATE STORE SLICE ------*/

export const addressBookSlice = createSlice({
    name: "addressBook",
    initialState: addressBookStateInitialState,
    reducers:{},
    extraReducers(builder){
      builder
      .addCase(fetchAddressBook.pending, (state) =>{
        state.status = ActionStatus.loading;
      })
      .addCase(fetchAddressBook.fulfilled, (state, action) =>{
        state.status = ActionStatus.succeeded;
        state.data = action.payload;
      })
      .addCase(fetchAddressBook.rejected, (state, action) => {
        state.status = ActionStatus.failed;
        state.error = action.error.message || '';
      })
    }
  });

/*----- CREATE REDUCER ------*/

export const addressBookReducer = addressBookSlice.reducer;